import formCreate from '@form-create/element-ui'

/**
 * fc-frame 在 render 的 nextTick 里把 form_create_helper 写到 iframe.contentWindow。
 * 那时文档还是 about:blank，页面真正打开后这个对象就没了，选用户/选图回传会失败。
 * 等 iframe 落到真实地址后再写一次，并挂上 formCreateHelper 别名（页面侧两种名字都在读）。
 */
export function patchFormCreateFrame() {
  const Frame = formCreate.component('fcFrame') as { methods?: { frameLoad?: Function & { __titaPatched?: boolean } } } | undefined
  const methods = Frame?.methods
  const origin = methods?.frameLoad
  if (!methods || !origin || origin.__titaPatched) return

  methods.frameLoad = function frameLoad(this: { $refs?: { frame?: HTMLIFrameElement } }, win: Window) {
    origin.call(this, win)
    try {
      const w = win as Window & { form_create_helper?: unknown; formCreateHelper?: unknown }
      if (w?.form_create_helper && !w.formCreateHelper) {
        w.formCreateHelper = w.form_create_helper
      }
    } catch {
      // 跨域 iframe 读不到 contentWindow
    }
    bindFrameLoad(this)
  }
  methods.frameLoad.__titaPatched = true
}

function bindFrameLoad(vm: { $refs?: { frame?: HTMLIFrameElement }; frameLoad?: (win: Window) => void }) {
  const el = vm?.$refs?.frame
  if (!el || (el as HTMLIFrameElement & { __titaFrameBound?: boolean }).__titaFrameBound) return
  ;(el as HTMLIFrameElement & { __titaFrameBound?: boolean }).__titaFrameBound = true

  let lastWin: Window | null = null
  let timer = 0
  const stop = () => window.clearInterval(timer)
  const apply = () => {
    if (!el.isConnected) {
      stop()
      return
    }
    try {
      const win = el.contentWindow
      if (!win || win === window) return
      const href = win.location?.href || ''
      if (!href || href === 'about:blank') return
      const helper = (win as Window & { form_create_helper?: unknown }).form_create_helper
      if (win === lastWin && helper) return
      lastWin = win
      vm.frameLoad?.(win)
    } catch {
      // 跨域
    }
  }

  timer = window.setInterval(apply, 50)
  el.addEventListener('load', () => {
    apply()
    // about:blank 也会触发 load，这时还不能停，否则真实页面加载后 helper 写不进去
    try {
      const href = el.contentWindow?.location?.href || ''
      if (href && href !== 'about:blank') stop()
    } catch {
      stop()
    }
  })
  window.setTimeout(stop, 10000)
}
